import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class NetworkServiceService {
  public networkListRef: firebase.database.Reference;

  constructor(private db: AngularFireDatabase) {
    this.networkListRef = db.database.ref('/com_shelcaster_broadcast_portal');
  }

  getNetwork() {
    return this.networkListRef.child('network_portal');
  }
}
